export function useCookie() {
  /**
   * 쿠키 이름으로 조회
   * @param name - 쿠키 키
   * @returns 쿠키 값 또는 null
   */
  const getCookie = (name: string): string | null => {
    const nameEq = `${encodeURIComponent(name)}=`;
    const hit = document.cookie
      .split(';')
      .map((s) => s.trim())
      .find((s) => s.startsWith(nameEq));
    return hit ? decodeURIComponent(hit.slice(nameEq.length)) : null;
  };

  /**
   *
   * @param name - 쿠키 이름
   * @param opts
   */
  const removeCookie = (name: string): void => {
    const enc = encodeURIComponent;
    const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    const path = '/';
    const host = location.hostname;

    // host-only
    document.cookie =
      `${enc(name)}=` +
      `; Expires=${expires}` +
      `; Max-Age=0` +
      `; Path=${path}` +
      `${secure}` +
      `; SameSite=Lax`;

    // Domain=현재 호스트
    document.cookie =
      `${enc(name)}=` +
      `; Expires=${expires}` +
      `; Max-Age=0` +
      `; Path=${path}` +
      `; Domain=${host}` +
      `${secure}` +
      `; SameSite=Lax`;
  };

  return { getCookie, removeCookie };
}
